<template>
  <div class="risk-profile">
    <div class="header-card">
      <!-- <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="close()">
      </div> -->
      <div class="header-card-text">
        <h4 class="cabin-family bold">SIC Cooperative</h4>
      </div>
    </div>
      <div class="risk-profile-body">
        <div class="">
          <p class="">A cooperative (also known as co-operative, co-op, or coop) is
            "an autonomous association of persons united voluntarily to meet their common economic,
            social, and cultural needs and aspirations through a jointly-owned enterprise".</p>

          <p class="">As the definition above states, the cooperative is a bit different
            from the club in that it is a jointly owned enterprise by all members and risks are
            borne by all.</p>
          <p class="">People will contribute monthly and consistenly to the scheme.
            After a period of time specified by the cooperative, individuals have access to loans in
            proportion to their individual savings.</p>
          <p class="">Commodities, properties and other investments instruments as
            agreed will be carried out by the cooperative on behalf of it's members. </p>
          <p class="">Dividends will also be paid at the end of each financial year
            provided some profit was made.</p>
          <p class="">Please find below a link to one of the stories that informed
            the registration of the cooperative. We hope to be able to do this/ something
            similar one day.</p>
          <p class=""><a href="https://bit.ly/3m4uKPW" target="_blank">https://bit.ly/3m4uKPW</a></p>
          <p class="">If you would like to join, kindly complete this form and we will
            get across the application process.</p>
          <p class=""><a href="https://forms.gle/cmWSWYod6VCKmv7L7" target="_blank">https://forms.gle/cmWSWYod6VCKmv7L7</a></p>
          <p class="">Do note that there is a one-off non refundable application fee
            of N10,000 for the cooperative. </p>
        </div>
        <button class="primary-btn btn btn-block mt-4" @click="close">Continue</button>
      </div>
  </div>
</template>

<script>
export default {
  props: ['message'],
  data() {
    return {
      q7: '',
      loading: false,
    };
  },
  methods: {
    close() {
      localStorage.setItem('cooperative-popup', true);
      this.$emit('close');
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.risk-profile{
  min-height: 100vh;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  background-color: #F9F9F9;
  color: #000;
  &-body{
    text-align: left;
    padding: 1rem;
  }
}
.header-card-text{
  margin: .5rem auto;
}
.literacy-footer{
  position: relative;
  margin-top: 2rem;
  width: 100%;
}
p{
  margin-bottom: 0;
  margin-block-end: .5em;
}
a{
  color: #EE0E4C;
}
</style>
